import {
  Box,
  Typography,
  Paper,
  IconButton,
  InputBase,
  Grid,
} from "@mui/material";
import MicIcon from "@mui/icons-material/Mic";
import InsertEmoticonIcon from "@mui/icons-material/InsertEmoticon";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import SendIcon from "@mui/icons-material/Send";
import { icons } from "../../assets";
import useAdminSettings from "../../zustand/useAdminSettingsStore";
import { useState, useEffect } from "react";
import { database } from "../../firebase";
import { ref, onValue, push, serverTimestamp } from "firebase/database";
import useUserStore from "../../zustand/useUserStore";
import AppLoader from "../../components/appLoader";
import { sendGroupMessage } from "../../services/Chat";

const Chats = () => {
  const [allMessages, setAllMessages] = useState([]);
  const [messageText, setMessageText] = useState("");
  const { adminSettings } = useAdminSettings();
  const { user } = useUserStore();
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    if (!adminSettings?.workerChatRoomId) return;

    try {
      setIsLoading(true);
      const messagesRef = ref(
        database,
        `messages/${adminSettings.workerChatRoomId}`
      );
      onValue(messagesRef, (snapshot) => {
        const data = snapshot.val();
        if (data !== null) {
          const tempArr = Object.keys(data)
            .map((key) => ({
              id: key,
              ...data[key],
            }))
            .sort((a, b) => new Date(a.time) - new Date(b.time));
          setAllMessages(tempArr);
          console.log(tempArr, "Messages");
        } else {
          setAllMessages([]);
        }
      });
    } catch (error) {
      console.log(error, "Messages fetch error");
    } finally {
      setIsLoading(false);
    }
  }, [adminSettings?.workerChatRoomId]);

  const sendMessage = async () => {
    if (!messageText.trim() || !adminSettings?.workerChatRoomId) return;

    try {
      setIsLoading(true);

      // 1) Hit backend API to trigger push notifications for workers + save Notification
      const apiResponse = await sendGroupMessage({ message: messageText,  type :'notification' });
      console.log(apiResponse, "group message notification API response (admin)");

      // 2) Write message to Firebase Realtime DB for chat UI
      const messagesRef = ref(
        database,
        `messages/${adminSettings.workerChatRoomId}`
      );
      await push(messagesRef, {
        attachmentUrl: "",
        isRead: false,
        msg: messageText,
        sender: user?._id,
        time: Date.now(),
        userDetails: {
          firstName: user?.username,
          lastName: "",
          profileImage: "",
          designation: "admin",
        },
      });

      setMessageText("");
    } catch (error) {
      console.log(error, "Message send error");
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      sendMessage();
    }
  };

  return (
    <Box
      bgcolor="primary.bgLight"
      padding={"20px"}
      borderRadius={"22px"}
      mt={0}
    >
      <AppLoader isVisible={isLoading} />
      <Grid container spacing={2}>
        <Grid item sm={12} md={5}>
          <Typography variant="h4">Chat</Typography>
          <Typography variant="description">
            To communicate in the house
          </Typography>
        </Grid>
      </Grid>
      <Box
        bgcolor="#fff"
        mt={2}
        p={4}
        borderRadius={3}
        height={600}
        maxHeight="70vh"
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        overflow="hidden"
        border="1px solid #388e3c"
      >
        <Box
          bgcolor="#fff"
          p={2}
          borderRadius={3}
          flex={1}
          minHeight={0}
          display="flex"
          flexDirection="column"
          overflow="hidden"
          border="1px solid #388e3c"
        >
          <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto", p: 2, pb: 0 }}>
            {allMessages.map((msg) => {
              const isMyMessage = msg.sender === user?._id;

              return (
                <Box
                  key={msg.id}
                  display="flex"
                  flexDirection="column"
                  alignItems={isMyMessage ? "flex-end" : "flex-start"}
                  mb={2}
                >
                  <Paper
                    elevation={0}
                    sx={{
                      bgcolor: isMyMessage
                        ? "rgba(124, 122, 122, 0.85)"
                        : "#388e3c",
                      color: "#fff",
                      borderRadius: "20px",
                      px: 2,
                      py: 0.5,
                      maxWidth: "70%",
                      minWidth: 80,
                      boxShadow: "none",
                      fontSize: 14,
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{ color: "#fff", fontSize: 14 }}
                    >
                      {msg.msg}
                    </Typography>
                  </Paper>
                  <Typography
                    variant="caption"
                    color="#bdbdbd"
                    mt={0.5}
                    sx={{
                      ml: isMyMessage ? 0 : 1,
                      mr: isMyMessage ? 1 : 0,
                    }}
                  >
                    {msg.userDetails?.firstName} {msg.userDetails?.lastName} •{" "}
                    {new Date(msg.time).toLocaleTimeString()}
                  </Typography>
                </Box>
              );
            })}
          </Box>
          {/* Input bar */}
          <Box
            display="flex"
            alignItems="center"
            bgcolor="#388e3c"
            borderRadius={5}
            mt={2}
            p={1.2}
          >
            {/* <IconButton sx={{ color: "#fff" }}>
              <img src={icons.micIcon} style={{ height: "24px" }} />
            </IconButton> */}
            <InputBase
              placeholder="Type Something"
              value={messageText}
              onChange={(e) => setMessageText(e.target.value)}
              onKeyPress={handleKeyPress}
              sx={{ ml: 1, flex: 1, color: "#fff", fontWeight: 500 }}
              inputProps={{ "aria-label": "type something" }}
            />
            {/* <IconButton sx={{ color: "#fff" }}>
              <img src={icons.emojiIcon} style={{ height: "24px" }} />
            </IconButton> */}
            {/* <IconButton sx={{ color: "#fff" }}>
              <img src={icons.attachIcon} style={{ height: "24px" }} />
            </IconButton> */}
            <IconButton sx={{ color: "#fff" }} onClick={sendMessage}>
              <img src={icons.sendIcon} style={{ height: "24px" }} />
            </IconButton>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Chats;
